<template>
  <div class="second">
    <div class="con"></div>
    <div class="word container">
      <h2 :class="['title', activeIndex === 1 ? 'animated fadeInUp' : '']">
        情商语文，让孩子会学语文，会生活！
      </h2>
      <p class="desc" :class="activeIndex === 1 ? 'animated fadeInUp' : ''">
        不同于传统的语文教学，心田花开凭借多年教学经验，创立了“情商语文”教学体系，激发孩子的学习兴趣和生活热情，增强孩子的学习能力和生活本领，让孩子“会”学语文，“会”生活！
      </p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    activeIndex() {
      return this.$store.state.activeIndex;
    }
  }
};
</script>
<style lang="less">
.second {
  height: 100vh;
  position: relative;
  background: url(../../assets/images/children.png) center no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  .con {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 1);
    opacity: 0.4;
    height: 100%;
    width: 100%;
    filter: alpha(opacity=60);
  }
  .word {
    height: 40%;
    width: 90%;
    text-align: center;
    position: relative;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin-top: 372px;
  }
  h2,
  p {
    margin: 0;
    padding: 0;
  }
  .title {
    width: 100%;
    height: 61px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: bold;
    line-height: 102px;
    color: rgba(255, 255, 255, 1);
    opacity: 1;
    text-align: center;
    margin-bottom: 80px;
  }
  .desc {
    width: 80%;
    // height: 141px;
    font-size: 24px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 41px;
    color: rgba(255, 255, 255, 1);
    opacity: 0.9;
    animation-delay: 0.3s;
  }
}
</style>
